import React from "react";
import style from "./display.module.scss";
import HomeContainer from "../containers/HomeContainer";
import NavbarContainer from "../containers/NavbarContainer";
import AboutContainer from "../containers/AboutContainer";
import ProyectsContainer from "../containers/ProyectsContainer";
import ContactoContainer from "../containers/ContactoContainer";
import FooterContainer from "../containers/FooterContainer";

function DisplayFull() {
  return (
    <div className={style.fatherContainer}>
      <div id="home" className={style.container}>
        <NavbarContainer />
        <HomeContainer />
      </div>
      <div id="aboutMe" className={style.about}>
        <AboutContainer />
      </div>
      <div id="projects" className={style.proyects}>
        <ProyectsContainer />
      </div>
      <div id="contacto" className={style.contacto}>
        <ContactoContainer />
      </div>
      <div className={style.footer}>
        <FooterContainer />
      </div>
    </div>
  );
}

export default DisplayFull;
